import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import DOMPurify from 'dompurify';
import axios from "axios";
import { sentryLog } from '../Utils/SentryLog';
import ExtensionNavbar from './ExtensionNavbar';

function SheetsExtensionFeedback(){

    const [statusMessage, setStatusMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const isShowConsole = process.env.NODE_ENV === 'development';

    const API_BASE_URL = process.env.NODE_ENV === 'development' 
    ? process.env.REACT_APP_LOCAL_API_URL 
    : process.env.REACT_APP_API_URL;

    const location = useLocation();
    isShowConsole && console.log("Current Path:", location.pathname); 

    const handleFeedbackSubmit = async(e) => {
        e.preventDefault();
        setIsLoading(true);
        const formData = {
            profession: DOMPurify.sanitize(e.target.profession.value),
            howDidYouFind: DOMPurify.sanitize(e.target.howDidYouFind.value),
            howDoesItHelp: DOMPurify.sanitize(e.target.howDoesItHelp.value),
            howCanWeImprove: DOMPurify.sanitize(e.target.howCanWeImprove.value),
            extraInfo: e.target.extraInfo.value
        };
        isShowConsole && console.log('sheets feedback form submitted: ', formData);

        try {
            const res = await axios.post(`${API_BASE_URL}/api/sheets-extension-feedback`, formData, { withCredentials: true });

            if (res.data.success) {
                setStatusMessage(res.data.message);
                e.target.reset();
                setIsSuccess(true);
                setIsLoading(false);
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            } else {
                setStatusMessage(res.data.error || 'Failed to send message.');
                setIsSuccess(false);
                setIsLoading(false);
            }
        } catch (err) {
            isShowConsole && console.error('Error submitting sheets feedback form:', err);
            sentryLog(`SheetsExtensionFeedback.js - /api/sheets-extension-feedback failed: ${err?.message || err}`);
            setStatusMessage((err.response && err.response.data && err.response.data.error) || "Something went wrong. Please try again later.");
            setIsSuccess(false);
            setIsLoading(false);
        }
    }
    
    return(
        <div className='parentDiv'>
            <div className='mainDiv sheetsFeedback'>
                <div className='header'>
                    <ExtensionNavbar feedbackPage={true} />
                </div>
                <div className='contentDiv'>
                    <div className='containerDiv'>
                        <div className='title'>We'd love to hear your feedback!</div>
                        <div className='contentBox'>
                            <div className='content'>
                                <form onSubmit={handleFeedbackSubmit}>
                                    <div className='sheetsFeedbackForm'>
                                        <div className="profession">
                                            <label htmlFor="profession">What best describes you? *<br/>
                                            </label>
                                            <div className="dropdownInput">
                                                <select id="profession" name="profession" required>
                                                    <option className="dropdownOption default" value="">-- Select --</option>
                                                    <option className="dropdownOption" value="accountant">accountant</option>
                                                    <option className="dropdownOption" value="bookkeeper">bookkeeper</option>
                                                    <option className="dropdownOption" value="auditor">auditor</option>
                                                    <option className="dropdownOption" value="small business owner">small business owner</option>
                                                    <option className="dropdownOption" value="financial analyst">financial analyst</option>
                                                    <option className="dropdownOption" value="business analyst">business analyst</option>
                                                    <option className="dropdownOption" value="data analyst">data analyst</option>
                                                    <option className="dropdownOption" value="logistics coordinator">logistics coordinator</option>
                                                    <option className="dropdownOption" value="operations manager">operations manager</option>
                                                    <option className="dropdownOption" value="supply chain analyst">supply chain analyst</option>
                                                    <option className="dropdownOption" value="administrative assistant">administrative assistant</option>
                                                    <option className="dropdownOption" value="data entry professional">data entry professional</option>
                                                    <option className="dropdownOption" value="researcher">researcher</option>
                                                    <option className="dropdownOption" value="student">student</option>
                                                    <option className="dropdownOption" value="sales operations analyst">sales operations analyst</option>
                                                    <option className="dropdownOption" value="marketing analyst">marketing analyst</option>
                                                    <option className="dropdownOption" value="hr coordinator">hr coordinator</option>
                                                    <option className="dropdownOption" value="procurement specialist">procurement specialist</option>
                                                    <option className="dropdownOption" value="project manager">project manager</option>
                                                    <option className="dropdownOption" value="other">other</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="how2imp">
                                            <label htmlFor="howDidYouFind">How did you find our app? *</label><br/>
                                            <textarea id="howDidYouFind" name="howDidYouFind" rows="1" cols="50" required></textarea>
                                        </div>
                                        <div className="how2imp">
                                            <label htmlFor="howDoesItHelp">How does the Google Sheets extension help you? *</label><br/>
                                            <textarea id="howDoesItHelp" name="howDoesItHelp" rows="1" cols="50" required></textarea>
                                        </div>
                                        <div className="how2imp">
                                            <label htmlFor="howCanWeImprove">Anything you want us to improve? *</label><br/>
                                            <textarea id="howCanWeImprove" name="howCanWeImprove" rows="1" cols="50" required></textarea>
                                        </div>
                                        <input
                                            type="text"
                                            name="extraInfo"
                                            className="hiddenInput"
                                            style={{ display: "none" }}
                                            tabIndex="-1"
                                            autoComplete="off"
                                        />
                                        <div className="submitDiv">
                                            <button className="submitBtn" type="submit">
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </form>
                                {statusMessage && 
                                    <div className='statusMsgCont'>
                                        <div className={`statusMessage ${isSuccess ? 'success' : 'failure'}`}>{statusMessage}</div>
                                    </div>
                                }
                                {isLoading && 
                                    <div className='loaderDiv'>
                                        Sending...
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SheetsExtensionFeedback;